import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Cannabis Louisiana · Elevate Your Understanding</p>
        <h1>Stay Informed on Cannabis Policy and Culture</h1>
        <p className="lede">
          At Cannabis Louisiana, we provide comprehensive coverage of local cannabis laws, policy updates, and cultural insights. Stay informed and engaged with the evolving landscape of cannabis in our community.
        </p>
        <div className="cta-row">
          <a href="/law-updates" target="_self">
            Explore Law Updates
          </a>
          <a href="/education" target="_self" className="secondary">
            Discover Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Insights</h2>
          <p>
            Keep up with the latest changes in cannabis legislation and understand how they impact our community.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information about the legal status of cannabis in Louisiana, including what is permitted and what is not.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Access a wealth of resources designed to educate you about cannabis culture, usage, and benefits.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;
